<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-03-21 11:24:12
 * @Description:
 * @LastEditors: fengxiaojing
-->
<template>
  <div>
    <el-card
      shadow="never"
      class="h-100 position-absolute volume_doc"
      :style="{ height: height, top: top }"
    >
      <div slot="header" class="clearfix business_dialog_title m-b-5">
        <span class="fz-14">卷册</span>
        <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
      </div>
      <div class="file_list h-100 p-10">
        <div v-for="item in docFileList" :key="item.id">
          <el-row :gutter="10">
            <el-tooltip
              :content="item.fileName + '[' + item.documentName + ']'"
              placement="top"
              effect="dark"
              open-delay="1000"
            >
              <!-- content to trigger tooltip here -->
              <el-col :span="19" class="text-overflow  fz-12 height-32 text-color-white"
                >{{ item.fileName }} [{{ item.documentName }}]</el-col
              >
            </el-tooltip>

            <el-col :span="5" class="tr height-32">
              <el-tooltip content="预览" placement="top" :open-delay="1000">
                <el-button
                  type="primary"
                  @click="viewMore(item)"
                  size="small"
                  class="iconfont icon-yxr-xsqb"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="分屏" placement="top" :open-delay="1000">
                <el-button
                  type="primary"
                  size="small"
                  class="iconfont icon-yxr-fp"
                  @click="splitScreen(item)"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
    <fileDialog :fileDialog="fileDialog" v-if="fileDialog.visible"></fileDialog>
  </div>
</template>
<script>
import DocumentService from '@/services/DocumentService'
import fileDialog from './components/fileDialog'

export default {
  name: 'VolumeDocuments',
  components: {
    fileDialog,
  },
  props: [
    'documentId',
    'currentModel',
    'player',
    'height',
    'top',
    'loadedModel',
    'isShowBasicCom',
    'tagCode',
  ],
  data() {
    return {
      fileDialog: {
        fileType: '',
        fileName: '',
        previewVersionTag: '',
        visible: '',
        resourceUrl: '',
      },
      docFileList: [],
    }
  },
  watch: {
    tagCode() {
      this.getAttributeInfo()
    },
  },
  async created() {
    if (this.tagCode) {
      this.getAttributeInfo()
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    closeComponent() {
      this.$emit('closeComponent', 'VolumeDocuments')
    },
    async viewMore(data) {
      if (_.last(_.split(data.fileName, '.')).toLowerCase() !== 'pr') {
        this.fileDialog.fileType = _.last(_.split(data.fileName, '.')).toLowerCase()
        if (this.fileDialog.fileType === 'wizdrawing') {
          const fileRes = await DocumentService.findFileUrl({
            id: data.md5,
          })
          if (fileRes) {
            this.fileDialog.resourceUrl = fileRes
          }
        } else {
          this.fileDialog.resourceUrl = `${currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.md5}`
        }
        this.fileDialog.fileName = data.fileName
        const res = await DocumentService.findDocAttr({
          documentId: data.documentId,
        })
        if (res && res.success && res.data) {
          if (this.fileDialog.fileType === 'svg') {
            this.fileDialog.resourceUrl = `/lib/svgView/index.html?file=${this.fileDialog.resourceUrl}`
            window.svgIframeId = 'previewSvg'
            window.svgFileId = data.fileId
          }
          this.fileDialog.previewVersionTag = res.data.versionTag
        }
        this.fileDialog.visible = true
      } else {
        window.open(`/#/modelDocView?documentId=${data.documentId}`)
      }
    },
    splitScreen(data) {
      const fileType = _.last(_.split(data.fileName, '.')).toLowerCase()
      this.$emit('splitScreen', { ...data, type: fileType })
    },
    async getAttributeInfo() {
      const res = await DocumentService.getDocumentByTagCode({
        siteId: this.currentProject.id,
        tagCode: this.tagCode,
      })
      if (res && res.code === 0 && res.data) {
        this.docFileList = res.data
      }
    },
  },
}
</script>
<style lang="scss">

@import '../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../css/index.scss';
.volume_doc {
  width: 368px;
  top: 76px;
  right: 35px;
  padding: 10px;
  border-radius: 4px;
  z-index: 99;
  background-color: rgba(46, 107, 176, 0.5) !important;
  &_table {
    height: calc(100% - 30px);
  }
}
/deep/ .el-card__body {
  padding: 0 !important;
  margin: 0 !important;
  height: calc(100% - 30px);
  tr.current-row > td {
    background-color: #e8e882;
  }
  tr.el-table__row--striped.current-row td {
    background-color: #e8e882 !important;
  }
}
.file_list {
  overflow-y: auto;
  background-color: rgba(24, 41, 72, 0.5) !important;
}

</style>
